import React from "react";
import { useAnnouncementsStore } from "../../../../stores/use-announcements-store";
import {
  AnnouncementsContentContainer,
  AnnouncementsGrid,
  DesignContainer,
} from "../../styles";
import Design from "../designs/Design";
import AddButton from "../../../cards-v2/components/editor/add-button/AddButton";
import Actions from "./components/actions/Actions";

function AnnouncementsEditor() {
  const {
    data,
    updateData,
    selectedAnnouncement,
    setSelectedAnnouncement,
    config,
    hoveredAnnouncement,
    setHoveredAnnouncement,
  } = useAnnouncementsStore((state) => ({
    data: state.data,
    updateData: state.updateData,
    selectedAnnouncement: state.selectedAnnouncement,
    setSelectedAnnouncement: state.setSelectedAnnouncement,
    config: state.config,
    hoveredAnnouncement: state.hoveredAnnouncement,
    setHoveredAnnouncement: state.setHoveredAnnouncement,
  }));

  return (
    <AnnouncementsContentContainer>
      <AnnouncementsGrid numberOfColumns={config.columns}>
        {data.map((announcement) => (
          <DesignContainer
            key={announcement.id}
            onClick={() => setSelectedAnnouncement(announcement.id)}
            onMouseEnter={() => setHoveredAnnouncement(announcement.id)}
            onMouseLeave={() => setHoveredAnnouncement(undefined)}
            isSelected={announcement.id === selectedAnnouncement}
          >
            {hoveredAnnouncement === announcement.id && <Actions />}
            <Design
              data={announcement}
              config={config}
              isEditable
              viewMode="edit"
            />
          </DesignContainer>
        ))}
        <AddButton
          hasCards={!!data.length}
          onClick={() => {
            const existingAnnouncement = data.at(0);
            updateData([
              ...data,
              {
                ...existingAnnouncement,
                url: {},
                newTab: "true",
                id: crypto.randomUUID(),
              },
            ]);
          }}
        />
      </AnnouncementsGrid>
    </AnnouncementsContentContainer>
  );
}

export default AnnouncementsEditor;
